import { Link } from "react-router-dom";

interface AuthShellProps {
  children: React.ReactNode;
  /** StudentPreferences is the one funnel page that needs the wider column. */
  maxWidth?: "md" | "lg";
  /** Content rendered under the card (only SignIn's dev account switcher today). */
  belowCard?: React.ReactNode;
}

// The one scaffold for the auth/onboarding funnel's centered-card pages
// (Round K): full-height centered wrapper + the logo lockup. Pages keep their
// own <Card> — the card internals vary too much (2FA step swap, text-center
// variant) to share more than the frame.
export default function AuthShell({ children, maxWidth = "md", belowCard }: AuthShellProps) {
  return (
    <div className="relative min-h-screen flex items-center justify-center bg-background p-4 py-12">
      <div className={`relative w-full ${maxWidth === "lg" ? "max-w-lg" : "max-w-md"}`}>
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <img src="/images/logo/navbar-logo.svg" alt="Jynio" className="w-12 h-12 rounded-xl" />
          {/* The brand, never machine-translated. */}
          <span translate="no" className="text-2xl font-display font-bold text-foreground">Jynio</span>
        </Link>
        {children}
        {belowCard}
      </div>
    </div>
  );
}
